/* eslint-disable newline-before-return */
import { FC, useState, ChangeEvent, useEffect, useContext } from 'react';
import {
  Button,
  Checkbox,
  Grid,
  TextArea,
  Dimmer,
  Icon,
  Loader,
} from 'semantic-ui-react';
import { RouteComponentProps } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import useSentence from 'hooks/Sentence';
import { AppContext } from 'App';
import { Predictions } from 'aws-amplify';

type PageProps = RouteComponentProps<{ id: string }>;

const Component: FC<PageProps> = (props) => {
  const id = props.match.params.id;
  const { state, dispatch } = useContext(AppContext);
  const [en, setEn] = useState('');
  const [jp, setJp] = useState('');
  const [answer, setAnswer] = useState('');
  const [checked, setChecked] = useState(0);
  const [hasNext, setHasNext] = useState(false);
  const [hasPrev, setHasPrev] = useState(false);
  const [hasCheckedNext, setHasCheckedNext] = useState(false);
  const [hasCheckedPrev, setHasCheckedPrev] = useState(false);
  const [checkedNextId, setCheckedNextId] = useState('');
  const [checkedPrevId, setCheckedPrevId] = useState('');
  const [show, setShow] = useState(false);
  const history = useHistory();
  const { isLoading, getOne, update, fetch } = useSentence({
    needToFetch: false,
  });

  useEffect(() => {
    getOne(id).then((result) => {
      setJp(result.jp);
      setChecked(result.checked);
      setAnswer(result.en);
      setEn('');
      checkPrevNext();
    });
  }, [id]);

  const checkPrevNext = () => {
    setShow(false);
    const current = state.sentenceIds.indexOf(id);
    if (state.sentenceIds.length === 0) history.push('/sentence');
    setHasNext(state.sentenceIds.length - 1 !== current);
    setHasPrev(current !== 0);

    if (state.checkedSencenteIds.length === 0) {
      setHasCheckedNext(false);
      setHasCheckedPrev(false);
      return;
    }
    setHasCheckedPrev(false);
    if (current != 0) {
      for (let i = current - 1; i >= 0; i--) {
        if (state.checkedSencenteIds.includes(state.sentenceIds[i])) {
          setHasCheckedPrev(true);
          setCheckedPrevId(state.sentenceIds[i]);
          break;
        }
      }
    }

    setHasCheckedNext(false);
    for (let i = current + 1; i <= state.sentenceIds.length; i++) {
      if (state.checkedSencenteIds.includes(state.sentenceIds[i])) {
        setHasCheckedNext(true);
        setCheckedNextId(state.sentenceIds[i]);
        break;
      }
    }
  };

  const next = () => {
    const current = state.sentenceIds.indexOf(id);
    if (state.sentenceIds.length === 0) history.push('/sentence');
    if (state.sentenceIds.length - 1 === current) return;
    history.push(`/checktest/${state.sentenceIds[current + 1]}`);
  };

  const prev = () => {
    if (state.sentenceIds.length === 0) history.push('/sentence');
    const current = state.sentenceIds.indexOf(id);
    if (current === 0) return;
    history.push(`/checktest/${state.sentenceIds[current - 1]}`);
  };

  const nextChecked = () => {
    history.push(`/checktest/${checkedNextId}`);
  };

  const pervChecked = () => {
    history.push(`/checktest/${checkedPrevId}`);
  };

  const speech = () => {
    Predictions.convert({
      textToSpeech: {
        source: {
          text: answer,
        },
      },
    }).then((result) => {
      const AudioContext = window.AudioContext;
      const audioCtx = new AudioContext();
      const source = audioCtx.createBufferSource();
      audioCtx.decodeAudioData(result.audioStream, (buffer) => {
        source.buffer = buffer;
        source.connect(audioCtx.destination);
        source.start(0);
      });
    });
  };

  return (
    <>
      {isLoading && (
        <Dimmer active inverted>
          <Loader>Loading...</Loader>
        </Dimmer>
      )}
      <Grid>
        <Grid.Row>
          <p>問題:</p>
        </Grid.Row>
        <Grid.Row>
          <p>{jp}({answer.split(' ').length}文字)</p>
          <Icon
            name="talk"
            size="large"
            color="green"
            onClick={() => speech()}
            style={{ cursor: 'pointer' }}
          />
        </Grid.Row>
        <Grid.Row>
          <a style={{ cursor: 'pointer' }} onClick={() => setShow(!show)}>
            {show ? '非表示' : '答え表示'}
          </a>
        </Grid.Row>
        {show && (
          <Grid.Row>
            <p>{answer}</p>
            <Icon
              name="talk"
              size="large"
              color="green"
              onClick={() => speech()}
              style={{ cursor: 'pointer' }}
            />
          </Grid.Row>
        )}
        <Grid.Row>
          <TextArea
            placeholder="Input English sentence"
            style={{ minHeight: 100, width: '100%' }}
            value={en}
            onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
              const value = String(event.target.value);
              setEn(value);
            }}
          />
        </Grid.Row>
        <Checkbox
          checked={checked === 1}
          onClick={async () => {
            update(id, checked === 1 ? 0 : 1);
            setChecked(checked === 1 ? 0 : 1);
            const result = await fetch();
            dispatch({
              type: 'SET_SENTENCE_IDS',
              payload: {
                sentenceIds: result.map((v) => v.id),
                checkedSencenteIds: result
                  .filter((v) => v.checked === 1)
                  .map((v) => v.id),
              },
            });
          }}
          label="この問題をチェック"
        />
        {en.replace('.', '').replace(' ', '').replace(',', '').toLowerCase() ===
          answer
            .replace('.', '')
            .replace(',', '')
            .replace(' ', '')
            .toLowerCase() ? (
          <Icon name="check circle" size="large" color="green" />
        ) : (
          <Icon name="times" size="large" color="red" />
        )}
        <div>
          {en.length === 0 ? 0 : en.split(' ').length}:文字
        </div>
        <Grid.Row>
          <div>
            <Button
              content="Prev"
              icon="left arrow"
              labelPosition="left"
              color="green"
              disabled={!hasPrev}
              onClick={() => prev()}
            />
            <Button
              content="Next"
              icon="right arrow"
              color="green"
              labelPosition="right"
              disabled={!hasNext}
              onClick={() => next()}
            />

            <Button
              content="Checked Prev"
              icon="left arrow"
              labelPosition="left"
              color="blue"
              disabled={!hasCheckedPrev}
              onClick={() => pervChecked()}
            />
            <Button
              content="Checked Next"
              icon="right arrow"
              color="blue"
              labelPosition="right"
              disabled={!hasCheckedNext}
              onClick={() => nextChecked()}
            />
          </div>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default Component;
